import type { ActivityStats } from "@mythic/coms/types";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from "recharts";

interface Props {
    data: ActivityStats[];
}

export function Graph({ data }: Props) {
    return (
        <ResponsiveContainer
            style={{ flex: 1, zIndex: "1", position: "relative" }}
        >
            <BarChart
                layout="vertical"
                data={data}
                margin={{ left: 48, right: 20 }}
            >
                <defs>
                    <linearGradient
                        id="barGradient"
                        x1="0"
                        y1="0"
                        x2="1"
                        y2="0"
                    >
                        <stop offset="0%" stopColor="var(--accent-d)" />
                        <stop offset="100%" stopColor="var(--accent-b)" />
                    </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" />

                <XAxis type="number" />
                <YAxis dataKey="_id" type="category" width={100} />

                <Tooltip
                    contentStyle={{
                        backgroundColor: "var(--primary-b)",
                        borderRadius: "1em",
                    }}
                />

                <Bar
                    dataKey="count"
                    fill="url(#barGradient)"
                    radius={[0, 8, 8, 0]}
                />
            </BarChart>
        </ResponsiveContainer>
    );
}
